export function parseWeight(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed.replace(',', '.'));
  if (!Number.isFinite(parsed) || parsed < 0) throw new Error('Введите корректный вес не меньше нуля.');
  return Math.round(parsed * 100) / 100;
}

export function parseRepetitions(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!/^\d+$/.test(trimmed)) throw new Error('Введите целое число повторений.');
  const parsed = Number(trimmed);
  if (!Number.isSafeInteger(parsed) || parsed < 0) throw new Error('Введите корректное число повторений.');
  return parsed;
}

export function normalizeExerciseName(value: string): string {
  return value.trim().replace(/\s+/g, ' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('ru-RU');
}

export function displayExerciseName(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function formatWeight(value: number): string {
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value);
}

export const restPresets = [30, 45, 60, 75, 90, 120, 150, 180, 240, 300] as const;
export const quickRestPresets = [30, 60, 90, 120, 180] as const;

export function isValidRestDuration(seconds: number): boolean {
  return Number.isInteger(seconds) && seconds >= 15 && seconds <= 900 && seconds % 15 === 0;
}

export function normalizeRestDuration(seconds: number): number {
  return Math.min(900, Math.max(15, Math.round(seconds / 15) * 15));
}

export function formatRestDuration(seconds: number): string {
  if (seconds < 60) return `${seconds} сек`;
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return rest === 0 ? `${minutes} мин` : `${minutes} мин ${rest} сек`;
}
